import script from "./DeleteTireModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteTireModal.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteTireModal.vue?vue&type=style&index=0&id=00e5b0f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e5b0f0"]])

export default __exports__